import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { trigger, state, style, animate, transition, AnimationEvent } from '@angular/animations';

import {
  keys as _keys,
  each as _each
} from 'lodash';

import { DialogService } from './dialog.service';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { Dialog } from './dialog';


/**
 * Root view for dialogs
 */
@Component({
  selector: 't-dialogs',
  templateUrl: './dialogs.component.html',
  entryComponents: [
    ConfirmDialogComponent,
  ],
  styles: [
    `.dialogs-shadow {
      position: fixed;
      background-color: #000000;
      z-index: 200;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      opacity: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            display: 'block',
            opacity: 0.1
          })
        ),
        state(
          'closed',
          style({
            display: 'none',
            opacity: 0
          })
        ),
        transition('closed <=> open', animate('400ms linear')),
      ]
    ),
  ]
})
export class DialogsComponent implements OnInit {

  state: string = 'closed';
  dialog: ComponentRef<{}> = null;

  @ViewChild(
    'dialogsPlaceholder',
    {
      read: ViewContainerRef
    }
  )
  dialogsPlaceholder: ViewContainerRef;

  constructor(private dialogService: DialogService, private resolver: ComponentFactoryResolver) { }

  ngOnInit(): void {

    this.dialogService.currentDialog.subscribe((data) => {

      // Open a dialog
      if (data) {
        this.state = 'open';

        // Create the dialog
        let factory = this.resolver.resolveComponentFactory(data.component);
        let dialog = this.dialogsPlaceholder.createComponent(factory);

        // Init the dialog
        _each(_keys(data.props), (prop) => {
          dialog.instance[prop] = data.props[prop];
        });

        this.dialog = dialog;

        setTimeout(() => {
          (<Dialog>this.dialog.instance).state = 'open';
        }, 0);
      }

      // Close a dialog
      else {
        (<Dialog>this.dialog.instance).state = 'closed';
        this.state = 'closed';
      }

    });
  }

  // Wait for animation end to destroy the dialog
  dialogClosed(event: AnimationEvent) {
    if(event.toState === 'closed' && event.fromState === 'open') {
      this.dialog.destroy();
      this.dialogsPlaceholder.clear();
    }
  }
}
